import { AlertCircleIcon } from './Icons';
import styles from './ErrorNote.module.css';

import type { Notice } from '@/lib/errors';

/**
 * One calm banner for an error that stays on the screen: a title, and under it what to do. It is the only place the
 * error is shown, with no notice on top of it. Where a screen has no room for it, the notice goes in a toast instead.
 */
export function ErrorNote({ notice, testId }: { readonly notice: Notice; readonly testId?: string }): React.JSX.Element {
  return (
    <div className={styles.note} role="alert" data-testid={testId ?? 'error-note'}>
      <AlertCircleIcon size={18} className={styles.icon} />
      <div className={styles.body}>
        <p className={styles.title}>{notice.title}</p>
        {notice.text === undefined ? null : (
          <p className={styles.text}>
            {notice.text}
            {notice.detail === undefined ? null : <span className={styles.detail}> ({notice.detail})</span>}
          </p>
        )}
      </div>
    </div>
  );
}
